import { MainComponent } from './Pages/main/main.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/ufa', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./Pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: MainComponent,
    children: [
      {
        path: 'actualites',
        loadChildren: () =>
          import('./Pages/actuality-page/actuality-page.module').then(
            (m) => m.ActualityPageModule
          ),
      },
      {
        path: 'modifier-actualite/:id',
        loadChildren: () =>
          import('./Pages/edit-actuality/edit-actuality.module').then(
            (m) => m.EditActualityModule
          ),
      },
      {
        path: 'creer-actualite',
        loadChildren: () =>
          import('./Pages/new-actuality/new-actuality.module').then(
            (m) => m.NewActualityModule
          ),
      },
      {
        path: 'formations/:id',
        loadChildren: () =>
          import('./Pages/formation-page/formation-page.module').then(
            (m) => m.FormationPageModule
          ),
      },
      {
        path: 'creer-formation/:id',
        loadChildren: () =>
          import('./Pages/new-formation/new-formation.module').then(
            (m) => m.NewFormationModule
          ),
      },
      {
        path: 'modifier-formation/:id',
        loadChildren: () =>
          import('./Pages/edit-formation/edit-formation.module').then(
            (m) => m.EditFormationModule
          ),
      },
      {
        path: 'administrateurs',
        loadChildren: () =>
          import('./Pages/administrator/administrator.module').then(
            (m) => m.AdministratorModule
          ),
      },
      {
        path: 'modifier-administrateur/:id',
        loadChildren: () =>
          import('./Pages/edit-administrator/edit-administrator.module').then(
            (m) => m.EditAdministratorModule
          ),
      },
      {
        path: 'ajouter-administrateur',
        loadChildren: () =>
          import('./Pages/add-administrator/add-administrator.module').then(
            (m) => m.AddAdministratorModule
          ),
      },
      {
        path: 'ufa',
        loadChildren: () =>
          import('./Pages/ufa/ufa.module').then((m) => m.UfaModule),
      },
      {
        path: 'ajouter-ufa',
        loadChildren: () =>
          import('./Pages/add-ufa/add-ufa.module').then((m) => m.AddUfaModule),
      },
      {
        path: 'modifier-ufa/:id',
        loadChildren: () =>
          import('./Pages/edit-ufa/edit-ufa.module').then(
            (m) => m.EditUfaModule
          ),
      },
      {
        path: 'poles',
        loadChildren: () =>
          import('./Pages/poles/poles.module').then((m) => m.PolesModule),
      },
      {
        path: 'ajouter-pole',
        loadChildren: () =>
          import('./Pages/add-pole/add-pole.module').then(
            (m) => m.AddPoleModule
          ),
      },
      {
        path: 'modifier-pole/:id',
        loadChildren: () =>
          import('./Pages/edit-pole/edit-pole.module').then(
            (m) => m.EditPoleModule
          ),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./Pages/faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'ajouter-faq',
        loadChildren: () =>
          import('./Pages/add-faq/add-faq.module').then((m) => m.AddFaqModule),
      },
      {
        path: 'modifier-faq/:id',
        loadChildren: () =>
          import('./Pages/edit-faq/edit-faq.module').then(
            (m) => m.EditFaqModule
          ),
      },
      {
        path: 'avis-employeurs',
        loadChildren: () =>
          import('./Pages/employers-opinions/employers-opinions.module').then(
            (m) => m.EmployersOpinionsModule
          ),
      },
      {
        path: 'ajouter-avis-employeur',
        loadChildren: () =>
          import(
            './Pages/add-employers-opinions/add-employers-opinions.module'
          ).then((m) => m.AddEmployersOpinionsModule),
      },
      {
        path: 'modifier-avis-employeur/:id',
        loadChildren: () =>
          import(
            './Pages/edit-employers-opinions/edit-employers-opinions.module'
          ).then((m) => m.EditEmployersOpinionsModule),
      },
      {
        path: 'fiche-metier',
        loadChildren: () =>
          import('./Pages/business-card/business-card.module').then(
            (m) => m.BusinessCardModule
          ),
      },
      {
        path: 'offres-d-apprentissage',
        loadChildren: () =>
          import('./Pages/learning-offers/learning-offers.module').then(
            (m) => m.LearningOffersModule
          ),
      },
      {
        path: 'ajouter-offre-d-apprentissage',
        loadChildren: () =>
          import('./Pages/add-learning-offers/add-learning-offers.module').then(
            (m) => m.AddLearningOffersModule
          ),
      },
      {
        path: 'modifier-offre-d-apprentissage/:id',
        loadChildren: () =>
          import(
            './Pages/edit-learning-offers/edit-learning-offers.module'
          ).then((m) => m.EditLearningOffersModule),
      },
    ],
  },
  { path: '**', redirectTo: 'page-not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
